import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import ScheduleIcon from '@mui/icons-material/Schedule';

import i18n from 'FRONTEND/utils/i18n';

export const getAvailableExpertSupport = () => {
  return {
    title: i18n._('How to find the practitioner?'),
    text: i18n._('You are able to select any available user for the appointment. If they did not delegate their calendar management to you in their profile settings, they will have to approve the appointment.'),
    paragraphList: [
      {
        title: i18n._('Make sure a practitioner is available'),
        text: i18n._('Only the practitioners who have some availabilities for the appointment type you have specified are listed here. If they delegated their calendar to you, you are able to edit their availabilities.'),
        icon: EventAvailableIcon,
      },
      {
        title: i18n._('Try another time slot or appointment type'),
        text: i18n._('Some practitioners might only be available for other time slots or appointment types.'),
        icon: ScheduleIcon,
      },
    ],
  };
};
